import { render, staticRenderFns } from "./AdditionalNotes.vue?vue&type=template&id=16abd962"
import script from "./AdditionalNotes.vue?vue&type=script&lang=ts"
export * from "./AdditionalNotes.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalNotes.vue?vue&type=style&index=0&id=16abd962&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16abd962')) {
      api.createRecord('16abd962', component.options)
    } else {
      api.reload('16abd962', component.options)
    }
    module.hot.accept("./AdditionalNotes.vue?vue&type=template&id=16abd962", function () {
      api.rerender('16abd962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/ClientRightSide/AdditionalNotes.vue"
export default component.exports